import {
  EmailOutlined,
  Instagram,
  Call,
  FacebookOutlined,
} from "@mui/icons-material";

export const SOCIAL_LINKS = [
  {
    platform: "call",
    icon: <Call />,
    url: "tel:+919823393663",
  },
  {
    platform: "Email",
    icon: <EmailOutlined />,
    url: "mailto:hinnilopes@hotmail.com",
  },
  {
    platform: "facebook",
    icon: <FacebookOutlined />,
    url: "https://facebook.com",
  },
  {
    platform: "instagram",
    icon: <Instagram />,
    url: "https://instagram.com",
  },
];
